import React from 'react';
import { Outlet } from 'react-router-dom';

import { useScrollToTop } from 'common/hooks';

import Footer from './Footer';
import Header from './Header';

const Layout = () => {
  useScrollToTop();

  return (
    <React.Fragment>
      <Header />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
    </React.Fragment>
  );
};

export default Layout;
